import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step1 = ({ rfq, setRfq, setStep, storedUser }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const orgId = JSON.parse(localStorage.getItem("org"));
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/department?orgId=${orgId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setDepartments(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    setRfq({ ...rfq, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = rfq || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    const now = new Date();

    // const creationDate = data.creationDate ? new Date(data.creationDate) : null;
    const submissionDate = data.submissionDate
      ? new Date(data.submissionDate)
      : null;

    if (isEmpty(data.brief)) {
      newErrors.brief = "Long Description is required";
    } else if (data.brief.length > 1000) {
      newErrors.brief = "Long Description should be upto 1000 characters";
    }
    // if (!creationDate) {
    //   newErrors.creationDate = "RFQ Creation Date is required";
    // } else {
    //   const today = new Date();
    //   today.setHours(0, 0, 0, 0);
    //   if (creationDate < today) {
    //     newErrors.creationDate = "RFQ Creation Date cannot be in the past";
    //   }
    // }
    if (!submissionDate) {
      newErrors.submissionDate = "Quotes required by date is required";
    } else if (submissionDate < now) {
      newErrors.submissionDate =
        "Quotes required by date cannot be in the past";
    }
    // if (isEmpty(data.document)) newErrors.document = "Attachment is required";
    if (isEmpty(data.name)) newErrors.name = "Name is required";
    if (isEmpty(data.shortDesc)) newErrors.shortDesc = "Name is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (isEmpty(data.dept)) newErrors.dept = "Department is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${storedUser.username}`,
          {
            headers: { Authorization: `Bearer ${storedUser.accessToken}` },
          }
        );
        setRfq({
          ...rfq,
          name: res.data.name,
          email: res.data.email,
        });
      } catch (error) {
        console.log(error);
      }
    };
    getUser();
  }, []);

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/draft`,
        {
          username: storedUser.username,
          shortDesc: rfq.shortDesc,
          brief: rfq.brief,
          submissionDate: rfq.submissionDate,
          name: rfq.name,
          email: rfq.email,
          dept: rfq.dept,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setRfq(res.data);
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftRfqId=${rfq.draftRfqId}`,
        {
          shortDesc: rfq.shortDesc,
          brief: rfq.brief,
          submissionDate: rfq.submissionDate,
          name: rfq.name,
          email: rfq.email,
          dept: rfq.dept,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Create New RFQ</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "16%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">RFQ Details</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="brief">
              Comments/Brief about RFQ
              <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.brief && "input-error"}`}
              name="brief"
              id="brief"
              onChange={handleChange}
              rows={8}
              value={rfq && rfq.brief}
            ></textarea>
            {errors.brief && <p className="error">{errors.brief}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="shortDesc">
              Short Description about RFQ
              <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.shortDesc && "input-error"}`}
              type="text"
              name="shortDesc"
              id="shortDesc"
              onChange={handleChange}
              value={rfq && rfq.shortDesc}
            />
            {errors.shortDesc && <p className="error">{errors.shortDesc}</p>}
          </Grid2>
          {/* <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="creationDate">RFQ Creation Date</label>
            <input
              className={`${errors.creationDate && "input-error"}`}
              type="datetime-local"
              name="creationDate"
              id="creationDate"
              onChange={handleChange}
              value={rfq && rfq.creationDate}
            />
            {errors.creationDate && (
              <p className="error">{errors.creationDate}</p>
            )}
          </Grid2> */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="submissionDate">
              Quotes required by date<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.submissionDate && "input-error"}`}
              type="datetime-local"
              name="submissionDate"
              id="submissionDate"
              onChange={handleChange}
              value={rfq && rfq.submissionDate}
            />
            {errors.submissionDate && (
              <p className="error">{errors.submissionDate}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="name">
              Requisitioner Name<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.name && "input-error"}`}
              type="text"
              name="name"
              id="name"
              onChange={handleChange}
              value={rfq && rfq.name}
            />
            {errors.name && <p className="error">{errors.name}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="email">Email ID</label>
            <input
              className={`${errors.email && "input-error"}`}
              type="email"
              name="email"
              id="email"
              onChange={handleChange}
              value={rfq && rfq.email}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="dept">
              Department<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <select name="dept" id="dept" onChange={handleChange} 
              value={rfq && rfq.dept}
              className={`${errors.dept && "input-error"}`}
            >
              <option value="">--Select Department--</option>
              {departments?.map((dept) => (
                <option value={dept.deptId}>{dept.name}</option>
              ))}
            </select>
            {/* <input
              className={`${errors.dept && "input-error"}`}
              type="text"
              name="dept"
              id="dept"
              onChange={handleChange}
              value={rfq && rfq.dept}
            /> */}
            {errors.dept && <p className="error">{errors.dept}</p>}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={rfq && rfq.draftRfqId ? handleUpdate : handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step1;
